import(/* webpackMode: "eager" */ "/foodcarttracker/components/site-header.tsx")